export default "__VITE_ASSET__CF8T3e5Z__"